import { Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import NewAnalysisForm from './NewAnalysisForm';
import AnalysisProgressBar from './AnalysisProgressBar';
import {
  getAnalysisStatusMeta,
  isAnalysisInProgress
} from '../utils/analysisStatus';

type AnalysisIncompleteStateProps = {
  status?: number;
  taskId?: string;
  onRefresh?: () => void;
  showForm?: boolean;
};

const AnalysisIncompleteState = ({
  status,
  taskId,
  onRefresh,
  showForm = true
}: AnalysisIncompleteStateProps) => {
  const meta = getAnalysisStatusMeta(status);
  const inProgress = isAnalysisInProgress(status);

  return (
    <div className="d-flex flex-column gap-3">
      {showForm && <NewAnalysisForm />}
      {inProgress && taskId ? (
        <AnalysisProgressBar job_id={taskId} onFinished={onRefresh} />
      ) : null}
      <Card className="text-center">
        <Card.Body className="py-4 px-5 px-md-7">
          <div className="mb-3">
            <FontAwesomeIcon
              icon={meta.icon as IconProp}
              className={`text-${meta.variant}`}
              style={{ fontSize: '2rem' }}
            />
          </div>
          <h5 className="text-1000 mb-2">{meta.label}</h5>
          {meta.description ? (
            <p
              className="text-700 fs--1 mb-0 mx-auto"
              style={{ maxWidth: '40rem' }}
            >
              {meta.description}
            </p>
          ) : null}
        </Card.Body>
      </Card>
    </div>
  );
};

export default AnalysisIncompleteState;
